import { send } from '../../util';
import { PermeatorPlatform } from '../PermeatorExt';

const p: PermeatorPlatform =  {
    push(url:string) {
        send({
            type: 'changeIframeUrl',
            link: url
        });
    },
    open(url:string) {
        send({
            type: 'open',
            link: url
        });
    }
}

export default p;
